var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'button': _vm.useButtonClass },on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v("Button Text")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }